// Hero banner text alignment. Centre is the default, which is how every
// hero rendered before the setting existed.
const HERO_ALIGNMENT = {
  left: { row: 'justify-start', text: 'text-left' },
  center: { row: 'justify-center', text: 'text-center' },
  right: { row: 'justify-end', text: 'text-right' },
};

export function heroAlignment(value) {
  return HERO_ALIGNMENT[value] || HERO_ALIGNMENT.center;
}
